/* src/app/components/elibraryandcourse/e-library/e-library-details/e-library-dashboard/e-library-dashboard.component.scss */
.library-dashboard-view .card {
  height: 140px !important;
}
.library-dashboard-view .card .dropdown-content {
  padding: 0px !important;
}
.library-dashboard-view .card .dropdown-content .dropdown-item:hover {
  background-color: #e7e7e7 !important;
}
.library-dashboard-view .card .dropdown-content .dropdown-divider {
  margin: 0px !important;
}
.modal .modal-card {
  width: calc(100% - 20px) !important;
}
.survey-modal .card-content,
.poll-modal .card-content {
  padding: 1rem 1.5rem !important;
}
.survey-modal .survey-question:first-child h3,
.survey-modal .poll-question:first-child h3,
.poll-modal .survey-question:first-child h3,
.poll-modal .poll-question:first-child h3 {
  margin-top: 0px !important;
  font-size: 1.1rem !important;
}
.survey-modal .is-medium,
.poll-modal .is-medium {
  font-size: 1rem !important;
}
.assQuestTest .label {
  color: #353535 !important;
}
/*# sourceMappingURL=e-library-dashboard.component.css.map */
